import React, { createContext, useReducer } from 'react';
import config from 'config';
import PropTypes from 'prop-types';

export const WorkflowContext = createContext();

const WorkflowProvider = ({ workflow, children }) => {
	return <WorkflowContext.Provider value={workflow}>{children}</WorkflowContext.Provider>;
};

WorkflowProvider.propTypes = {
	workflow: PropTypes.object.isRequired,
	children: PropTypes.node,
};

const useWorkflowInfo = () => {
	const context = React.useContext(WorkflowContext);
	if (context === undefined) {
		throw new Error('useWorkflow must be used within a WorkflowProvider');
	}
	return context;
};

export { WorkflowProvider, useWorkflowInfo };
